import React from "react";
import Project from "./Project";
import gpsprojectpic from "./images/gps_proj.jpg";

const projects = [
  {
    index: "01",
    title: "Integrated Navigation System",
    domain: "Embedded / Signal Processing",
    description:
      "GPS alone updates once a second with ~5-meter accuracy — not enough for urban navigation. This system fuses GPS with IMU sensors (accelerometer and magnetometer) to raise precision and sampling rate, showing time, GPS status, speed, compass heading and Northing-Easting coordinates in real time on two LCD displays. Built on Arduino and simulated in MATLAB.",
    tags: ["Arduino", "GPS", "IMU", "MATLAB", "C/C++"],
    image: gpsprojectpic,
    imageCaption: "Fig. 01 — GPS/IMU field unit, dual LCD readout",
  },
  {
    index: "02",
    title: "Vending Machine",
    domain: "Embedded",
    description:
      "An Arduino-powered automated machine with a coin detector that recognises half, one and five shekel coins, dispensing beverages via unique codes. A companion mobile app shows the machine's total balance and allows secure cash withdrawal using RFID card authentication.",
    tags: ["Arduino", "RFID", "MIT App Inventor"],
  },
  {
    index: "03",
    title: "Todo App",
    domain: "Mobile / Backend",
    description:
      "A React Native app for creating, managing and tracking tasks with deadlines — complete, remove, done. Backed by a custom RESTful API written in Go with the Gin-Gonic framework and containerised with Docker for deployment.",
    tags: ["React Native", "Go · Gin", "Docker", "REST"],
  },
  {
    index: "04",
    title: "Event Landing Pages",
    domain: "Web",
    description:
      "A React-based event invitation site with RSVP functionality — guests confirm attendance and specify group size, with data managed through Sanity CMS. Deployed on Netlify, alongside this portfolio.",
    tags: ["React", "Sanity CMS", "Netlify"],
  },
];

const Projects = () => (
  <section id="projects" className="section">
    <div className="section-head">
      <span className="section-num">04</span>
      <h2>Projects</h2>
    </div>
    <div className="projects-list">
      {projects.map((project) => (
        <Project
          key={project.index}
          index={project.index}
          title={project.title}
          domain={project.domain}
          description={project.description}
          tags={project.tags}
          imagestr={project.image}
          imageCaption={project.imageCaption}
        />
      ))}
    </div>
  </section>
);

export default Projects;
